'use strict';

exports.__esModule = true;

var getEnv = exports.getEnv = function getEnv() {
  return process.env.NODE_ENV;
};

var isProduction = exports.isProduction = function isProduction() {
  return getEnv() === 'production';
};

var isDevelopment = exports.isDevelopment = function isDevelopment() {
  return getEnv() === 'development';
};

var isTest = exports.isTest = function isTest() {
  return getEnv() === 'test';
};

var isHeadless = exports.isHeadless = function isHeadless() {
  return Boolean(window.RUNNING_HEADLESS);
};

var isOffline = exports.isOffline = function isOffline() {
  return !!~window.location.search.indexOf('offline=true') || !navigator.onLine;
};

exports.default = getEnv;